app.controller("medicalCertificateController", [
	"$scope",
	"SurgeryAgreementAPI",
	"$modal",
	"CurrentPatient",
	"Session",
	"$filter",
	"$window",
    "$stateParams",
	"UPLOAD_SIGNATURE_IMAGE_1096",
	"FileUploader",
	function ($scope,SurgeryAgreementAPI,$modal,CurrentPatient,Session,$filter,$window,$stateParams,UPLOAD_SIGNATURE_IMAGE_1096,FileUploader) {
		this.$onInit = function () {
			$scope.today = $filter("date")(new Date(), "dd-MMMM-yyyy");
			$scope.CP = CurrentPatient;
            $scope.isReturnToWork = $stateParams.isReturnToWork;

			$scope.enableUploadImage = UPLOAD_SIGNATURE_IMAGE_1096;

			// The certificate prints the clinician's registration number and the backend fails without one.
			$scope.hasProfessionalRegistration = Session.hasProfessionalRegistration;

			$scope.uploadedItem = {};

			$scope.uploader = new FileUploader({
				queueLimit: 1,
			});
			// $scope.isHidden = false;

			$scope.uploader.onAfterAddingFile = function (item) {
				$scope.uploadedItem._file = item._file;

				var reader = new FileReader();

				reader.onload = async (loadEvent) => {
					var img = new Image();
					img.onload = function () {
						var width = this.width;
						var height = this.height;
						// Use width and height here (e.g., update scope, perform validation)
						// If updating scope, remember to call $scope.$apply()
						var image = loadEvent.target.result;

						resizeImage(image, width, height).then((resolve) => {
							// A native promise, so the preview only shows once Angular is told about it.
							$scope.$evalAsync(() => ($scope.uploadedItem.dataUrl = resolve));
						});
					};
					img.src = loadEvent.target.result; // Base64 encoded image data
				};
				reader.readAsDataURL(item._file);
			};

            if($scope.isReturnToWork){
                $scope.form = {
                    patient_id: $scope.CP.patient.id,
                    patient_email: $scope.CP.patient.email,
                    user_id: Session.user.id,
                    practice_id: Session.practice.id,
                    patient_certificate_type: 'RETURN_TO_WORK',
                    _date_of_consult_UTC: moment().utc().toISOString()
                };
            }else {
                $scope.form = {
                    patient_id: $scope.CP.patient.id,
                    patient_email: $scope.CP.patient.email,
                    user_id: Session.user.id,
                    practice_id: Session.practice.id,
                    patient_certificate_type: 'MEDICAL_CERTIFICATE'
                };
            }

			$scope.SAAPI = SurgeryAgreementAPI;
            $scope.saved_user_signature_image = null;
            // fetchSignature();
		};

		function resizeImage(imageURL, width, height) {
			return new Promise((resolve) => {
				const image = new Image();
				image.onload = function () {
					const canvas = document.createElement("canvas");
					canvas.width = 600;
					canvas.height = 200;
					const ctx = canvas.getContext("2d");

					var hRatio = canvas.width / width;
					var vRatio = canvas.height / height;
					var ratio = Math.min(hRatio, vRatio);

					if (ctx != null) {
		
						ctx.drawImage(image, 0, 0, width, height, (600 - width * ratio)/2, 0, width * ratio, height * ratio);
					}
					var data = canvas.toDataURL("image/png", 1);
					resolve(data);
				};
				image.src = imageURL;
			});
		}

        $scope.boundingBox = {
			width: 600,
			height: 600,
		};

        	// One could simply use Canvas#toBlob method instead, but it's just to show
		// that it can be done using result of SignaturePad#toDataURL.
		function dataURLToBlob(dataURL) {
			// Code taken from https://github.com/ebidel/filer.js
			const parts = dataURL.split(";base64,");
			const contentType = parts[0].split(":")[1];
			const raw = window.atob(parts[1]);
			const rawLength = raw.length;
			const uInt8Array = new Uint8Array(rawLength);

			for (let i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
			}

			return new Blob([uInt8Array], { type: contentType });
		}

        $scope.useClinicianSignature = function (accept) {
			let userBlob = null;
			if ($scope.uploadedItem.dataUrl) {
				userBlob = dataURLToBlob($scope.uploadedItem.dataUrl);
			} else {
				$scope.signatureClinician = accept();
				if ($scope.signatureClinician.isEmpty) {
					$scope.signatureClinician.dataUrl = null;
				}
				if (!$scope.signatureClinician.dataUrl) {
					return;
				}
				userBlob = dataURLToBlob($scope.signatureClinician.dataUrl);
			}
			$scope.SAAPI.isProcessing = true;
			$scope.SAAPI.uploadSignature(Session.user.id, userBlob)
				.then(
					function (resp) {
						if ($scope.signatureModal) {
							$scope.signatureModal.hide();
						}
					},
					function (error) {
						showErrorDialog();
					}
				)
				.then(() => ($scope.SAAPI.isProcessing = false));
		};

        $scope.fetchSignature = () => {
            $scope.SAAPI.isProcessing = true;
            $scope.SAAPI.fetchMedicalCertificateSetting(Session.user.id).then(
				function (resp) {
                    if(resp.data && resp.data.patient_certificate_settings && resp.data.patient_certificate_settings.saved_user_signature_image){
                        $scope.saved_user_signature_image = resp.data.patient_certificate_settings.saved_user_signature_image;
                        const saved_user_signature_image =
								"data:image/png;base64," + $scope.saved_user_signature_image;
							$scope.signatureClinician = { dataUrl: saved_user_signature_image };
                    }
                    $scope.signatureModal = $modal({
                        scope: $scope,
                        templateUrl: "app/src/views/templates/modal.preview-sign.tpl.html",
                        show: true,
                        title: "PREVIEW SIGNATURE",
                        backdrop: "static",
                        keyboard: false,
                    });
				},
				function (err) {
					showErrorDialog();
				}
			)
			.then(function () {
				$scope.SAAPI.isProcessing = false;
			});
        }

		$scope.positiveClick = ()=>{
			if($scope.signatureModal){
				$scope.signatureModal.hide();
			}
			if ($scope.serverErrorModal) {
                $scope.serverErrorModal.hide();
                $window.history.back();
            }
		}

		function showErrorDialog() {
			$scope.serverErrorModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
				show: true,
				title: "CatTrax has encountered an error",
			});
		}
    
		// The datepickers write "dd-MMMM-yyyy" and the date range "DD/MMM/YYYY - DD/MMM/YYYY"; neither is
		// ISO, so parse with the format rather than relying on moment's deprecated Date() fallback.
		const DATEPICKER_FORMATS = [moment.ISO_8601, "DD-MMMM-YYYY"];
		const RANGE_FORMAT = "DD/MMM/YYYY";
		// An empty picker meant "now" before (moment(undefined)); keep that. Text typed straight into an
		// input may not match the picker's format, so fall back to the browser's Date parse the old
		// moment(value) call relied on - an unparsed date would go to the API as null and be rejected.
		const parseDate = (value, formats) => {
			if (!value) {
				return moment();
			}
			const parsed = moment(value, formats, true);
			return parsed.isValid() ? parsed : moment(new Date(value));
		};

		$scope.submit = function (){
            if (!Session.hasProfessionalRegistration()) {
                return;
            }
            $scope.invalidDates = false;
            if ($scope.medicalForm) {
                $scope.medicalForm.$setSubmitted();
                if ($scope.medicalForm.$invalid) {
                    return;
                }
            }

            const dateOfConsult = parseDate($scope.form._date_of_consult_UTC, DATEPICKER_FORMATS);
            let leaveStart = null;
            let leaveEnd = parseDate($scope.form._leave_end_date_UTC, DATEPICKER_FORMATS);

            if(!$scope.isReturnToWork){
                const duration = ($scope.form.duration || '').split(' - ');
                if (duration.length !== 2) {
                    $scope.invalidDates = true;
                    return;
                }
                leaveStart = parseDate(duration[0].trim(), RANGE_FORMAT);
                leaveEnd = parseDate(duration[1].trim(), RANGE_FORMAT);
            }

            if (![dateOfConsult, leaveEnd, leaveStart].every((date) => date === null || date.isValid())) {
                $scope.invalidDates = true;
                return;
            }

            $scope.form.date_of_consult_UTC = dateOfConsult.utc().toISOString();
            $scope.form.leave_end_date_UTC = leaveEnd.utc().toISOString();
            if (leaveStart) {
                $scope.form.leave_start_date_UTC = leaveStart.utc().toISOString();
            }

			const form = angular.copy($scope.form);
		
			$scope.SAAPI.isProcessing = true;
			
			$scope.SAAPI.createMedicalCertificate($scope.CP.patient.id,form).then(
				function (resp) {
                    downloadFile(resp.data,getFileName());
                    $window.history.back();
				},
				function (err) {
					showErrorDialog();
				}
			)
			.then(function () {
				$scope.SAAPI.isProcessing = false;
			});


		}

		function getFileName() {
			var theTime = $filter("date")(new Date(), "yyyy-MM-dd@hmma");
			return (
				`CatTrax_${$scope.form.patient_certificate_type}_` +
				theTime +
				"_" +
				$scope.CP.patient.firstName +
				"_" +
				$scope.CP.patient.lastName +
				"_" +
				$scope.CP.patient.dateOfBirth +
				".pdf"
			);
		}

		function downloadFile(data, filename, mime, bom) {
			// https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
			var blobData = typeof bom !== "undefined" ? [bom, data] : [data];
			var blob = new Blob(blobData, { type: "application/pdf" });
			if (typeof window.navigator.msSaveBlob !== "undefined") {
				// IE workaround for "HTML7007: One or more blob URLs were
				// revoked by closing the blob for which they were created.
				// These URLs will no longer resolve as the data backing
				// the URL has been freed."
				window.navigator.msSaveBlob(blob, filename);
			} else {
				var blobURL = window.URL.createObjectURL(blob);
				var tempLink = document.createElement("a");
				tempLink.style.display = "none";
				tempLink.href = blobURL;
				tempLink.setAttribute("download", filename);

				// Safari thinks _blank anchor are pop ups. We only want to set _blank
				// target if the browser does not support the HTML5 download attribute.
				// This allows you to download files in desktop safari if pop up blocking
				// is enabled.
				if (typeof tempLink.download === "undefined") {
					tempLink.setAttribute("target", "_blank");
				}

				document.body.appendChild(tempLink);
				tempLink.click();
				document.body.removeChild(tempLink);
				window.URL.revokeObjectURL(blobURL);
				$scope.displaySpinner = false;
			}
		}

		$scope.uploadImage = function () {
			$scope.uploader.clearQueue();
			angular.element(document.querySelector("#upload_image")).trigger("click");
		}
	},
]);
